import React, { useState, useEffect } from "react";
import { DialogContent, DialogTitle, DialogActions } from "@material-ui/core";

import Chip from "../../components/basics/Chip";
import TableDefault from "../../components/grid/TableDefault";
import TextField from "../../components/basics/TextFieldErp";
import {
  CustomDialog,
  StyledSearchDialog,
  Header,
  Body,
} from "./styles/SearchDialog";
import Btn from "../../components/buttons/Btn";

const EmptySearchDialog = ({
  dataContent = [],
  disabledSearch = false,
  disabledCancelButton = false,
  title,
  open,
  setOpen,
  multiSelect = true,
  selectable = true,
  handleMainClick = () => {},
  columns,
}) => {
  const [selected, setSelected] = useState([]);
  const [textFilter, setTextFilter] = useState("");
  const [dataRows, setDataRows] = useState([]);

  useEffect(() => {
    setDataRows([...dataContent]);
  }, [dataContent]);

  const closeDialog = (reason) => {
    if (reason === "backdropClick") return;

    setOpen(false);
  };

  return (
    <CustomDialog
      fullWidth={true}
      maxWidth="lg"
      open={open}
      onClose={(e, reason) => closeDialog(reason)}
      aria-labelledby="dialog-title"
    >
      <StyledSearchDialog>
        <DialogTitle id="dialog-title">
          <Header>
            <Chip bgcolor="primary" textcolor="white" label={title} />
          </Header>
        </DialogTitle>
        <DialogContent>
          <Body>
            {!disabledSearch ? (
              <TextField
                label="Busque por qualquer coluna presente na tabela."
                variant="filled"
                value={textFilter}
                setValue={setTextFilter}
              />
            ) : (
              <></>
            )}
            <TableDefault
              maxHeight="45vh"
              columns={columns}
              values={dataRows}
              selectable={selectable}
              multiSelect={multiSelect}
              selected={selected}
              setSelected={setSelected}
              tableTitle=""
              stickyHeader
            />
          </Body>
        </DialogContent>
        <DialogActions>
          <Btn
            onClick={() => handleMainClick(setOpen, selected)}
            label="Selecionar"
          />
          {!disabledCancelButton ? (
            <Btn
              onClick={closeDialog}
              bgcolor="grey"
              label="Cancelar"
              hovercolor="blue"
            />
          ) : (
            <></>
          )}
        </DialogActions>
      </StyledSearchDialog>
    </CustomDialog>
  );
};

export default EmptySearchDialog;
